import { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import { usePendingTransactionsWithoutSuspense } from "../../hooks/useTransaction"

export const usePendingTransactionAlertCount = (token: string) => {
    const [count, setCount] = useState(0)
    const { data, refetch } = usePendingTransactionsWithoutSuspense(token, 0, 1)

    useEffect(() => {
        setCount(data?.pagination.total ?? 0)
    }, [data])

    // locationが変更されるたびにカウントを更新する
    const location = useLocation()
    useEffect(() => {
        refetch()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location])

    return {
        count
    }
}
